module.exports = __webpack_public_path__ + "static/pexels-5-2e68844bb6ca1d29eb928760997c6c11.png";